<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<script>
import WebLayout from '@/views/Layouts/WebLayout';
import MobileLayout from '@/views/Layouts/MobileLayout';
import GuestLayout from '@/views/Layouts/GuestLayout';
import AdminLayout from '@/views/Layouts/AdminLayout';

export default {
  name: 'layout-wrapper',
  components: {
    WebLayout,
    MobileLayout,
    GuestLayout,
    AdminLayout,
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  mounted() {
    console.log('Layout Wrapper mounted', this.layout);  
  },
  data() {
    return {
      initial: true,
      window: {
        width: 0,
      },
    };
  },
  computed: {
    route() {
      return this.$route;
    },
    layout() {
      return `${this.route.meta.layout}-layout`;
    },
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
  },
};
</script>
